<template>
  <div class="container">
    <div class="icons">
      <router-link
        tag="div"
        :class="icon.id === '2' ? 'between' : ''"
        :to="{ path: './' + $route.params.content, query: { ps: icon.name } }"
        v-for="icon in icons"
        :key="icon.id"
      >
        <img
          v-if="icon.id === '1'"
          class="on"
          src="../../assets/img/icon_1_on.svg"
          alt="Icon 1"
        />
        <img
          v-if="icon.id === '1'"
          class="off"
          src="../../assets/img/icon_1_off.svg"
          alt="Icon 1"
        />
        <img
          v-if="icon.id === '2'"
          class="on"
          src="../../assets/img/icon_2_on.svg"
          alt="Icon 2"
        />
        <img
          v-if="icon.id === '2'"
          class="off"
          src="../../assets/img/icon_2_off.svg"
          alt="Icon 2"
        />
        <img
          v-if="icon.id === '3'"
          class="on"
          src="../../assets/img/icon_3_on.svg"
          alt="Icon 3"
        />
        <img
          v-if="icon.id === '3'"
          class="off"
          src="../../assets/img/icon_3_off.svg"
          alt="Icon 3"
        />
        <span>{{ icon.title }}</span>
      </router-link>
    </div>
    <div class="scrollable">
      <div class="content">
        <div class="title">{{ content.title }} - {{ selectedIcon }}</div>
        <div v-html="contentDescription(content[$route.query.ps])"></div>
      </div>
    </div>
    <LovalFooter :links="links" />
  </div>
</template>

<script>
import LovalFooter from "../LovalFooter";
export default {
  components: {
    LovalFooter
  },
  props: ["content", "icons", "links"],
  mounted() {
    if (this.$store.state.arrowAnimation) {
      this.$store.commit("isArrowAnimation");
    }
  },
  computed: {
    selectedIcon() {
      return this.icons.find(obj => {
        return obj.name === this.$route.query.ps;
      }).title;
    }
  },
  methods: {
    contentDescription(content) {
      let linkText;
      switch (this.$route.params.lang) {
        case "ES":
          linkText = "más productos";
          break;
        case "DE":
          linkText = "mehr Produkte";
          break;
        default:
          linkText = "more products";
      }
      let link =
        "/#/" +
        this.$route.params.lang +
        "/nav/services?ps=" +
        this.$route.query.ps;
      link = "<a href='" + link + "'>" + linkText + "</a>";
      return content + link;
    }
  }
};
</script>
<style lang="scss" scoped>
@import url("./style.scss");
@import url("./industries-style.scss");
@media only screen and (min-width: 768px) {
  .scrollable {
    padding: 30px;
  }
}
@media only screen and (min-width: 1200px) {
  .content {
    padding: 20px 30px;
    background: var(--very-light-blue);
    border-top-left-radius: 30px;
    min-height: calc(100% - 40px);
  }
}
</style>
